export const getCurrentDateTime = () => {
    const now = new Date();
    const date = now.toLocaleDateString('en-US', {
      day: '2-digit',
      month: '2-digit'
    });
    const time = now.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
    return `T${time}-D${date}`;
  };
  
  export const getValidTimestamp = (() => {
    let lastSentTime = null;
    let lastTimestamp = null;
  
    return () => {
      const now = new Date();
      if (!lastSentTime) {
        const newTimestamp = getCurrentDateTime();
        lastTimestamp = newTimestamp;
        lastSentTime = now;
        return newTimestamp;
      }
      const timeDiff = (now - lastSentTime) / 1000 / 60;
      if (timeDiff > 5) {
        const newTimestamp = getCurrentDateTime();
        lastTimestamp = newTimestamp;
        lastSentTime = now;
        return newTimestamp;
      }
      lastSentTime = now;
      return lastTimestamp;
    };
  })();